/**
 * External dependencies
 */
import { isUndefined, pickBy } from "lodash";

/**
 * WordPress dependencies
 */
import { __ } from "@wordpress/i18n";
import { compose } from "@wordpress/compose";
import { withSelect } from "@wordpress/data";
import { InspectorControls } from "@wordpress/block-editor";
import {
	PanelBody,
	Placeholder,
	ServerSideRender,
	Spinner,
	TextControl,
    RangeControl,
	SelectControl,
} from "@wordpress/components";

/**
 * Block edit function
 *
 * @param {Object} props for the component
 */
const NavMenu = (props) => {
	const { attributes, setAttributes, navMenus, className, isSelected } = props;

	const { menu, depth, containerAriaLabel, themeLocation, align } = attributes;

	const hasNavMenus = Array.isArray(navMenus) && navMenus.length;

	let menuOptions = [];
	if (hasNavMenus) {
		menuOptions.push({ value: 0, label: __("Select a menu", "a3web-blocks") });
		navMenus.forEach((navMenu) => {
			menuOptions.push({ value: navMenu.id, label: navMenu.name });
		});
	} else {
		menuOptions.push({ value: 0, label: __("Loading...", "a3web-blocks") });
	}

	if (!hasNavMenus) {
		<>
			<Placeholder icon="menu" label={__("Navigation Menu", "a3web-blocks")}>
				{!Array.isArray(navMenus) ? (
					<Spinner />
				) : (
					<>{__("No menu found. Start creating a menu.", "a3web-blocks")}</>
				)}
			</Placeholder>
		</>;
	}

	return (
		<>
			<InspectorControls>
				<PanelBody title={__("Settings", "a3web-blocks")} initialOpen={true}>
					<SelectControl
						label={__("Menu", "a3web-blocks")}
                        help={__("Desired menu.", "a3web-blocks")}
						value={menu}
						onChange={(value) => setAttributes({ menu: value })}
						options={menuOptions}
					/>
                    <RangeControl
						label={__("Depth", "a3web-blocks")}
                        help={__("How many levels of the hierarchy are to be included. 0 means all.", "a3web-blocks")}
						value={depth}
						onChange={(value) => setAttributes({ depth: value })}
						min={0}
						max={10}
					/>
					<TextControl
						label={__("Container ARIA Label", "a3web-blocks")}
                        help={__("The aria-label attribute that is applied to the container when it's a nav element.", "a3web-blocks")}
						value={containerAriaLabel}
						onChange={(value) => setAttributes({ containerAriaLabel: value })}
					/>
				</PanelBody>
			</InspectorControls>
			<ServerSideRender block="a3web-blocks/nav-menu" attributes={attributes} />
		</>
	);
};

export default compose([
	withSelect((select) => {
		const { getEntityRecords } = select("core");

		const navMenuQuery = () => {
			const navMenusQuery = pickBy(
				{
					orderby: "name",
					hide_empty: false,
				},
				(value) => !isUndefined(value)
			);
			let navMenus = getEntityRecords("taxonomy", "nav_menu", navMenusQuery);
			return !Array.isArray(navMenus)
				? navMenus
				: navMenus.map((navMenu) => {
						return navMenu;
				  });
		};

		return {
			navMenus: navMenuQuery(),
		};
	}),
])(NavMenu);
